import { Helmet } from 'react-helmet'
import styles from './styles/MaintenanceApp.css'

const MaintenanceApp = () => {
  const assets = CONFIG.assetsBaseURL
  return (
    <div className={styles.page}>
      <Helmet>
        <link rel='canonical' href='https://scite.ai/' />
        <meta property='og:image' content='http://image.thum.io/get/ogImage/https://scite.ai?bannerClosed=true&v=2' />
        <meta property='twitter:image' content='http://image.thum.io/get/ogImage/https://scite.ai?bannerClosed=true&v=2' />
      </Helmet>

      <div>
        <div className={styles.topbar}>
          <img
            src={`${assets}/images/logo-blue.svg`}
            alt='scite logo'
          />
        </div>

        <div className={styles.contentWrapper}>
          <div className={styles.leftContainer}>
            <img
              src={`${assets}/images/maintenance.png`}
              alt='Maintenance icon created by Freepik - Flaticon'
              className={styles.maintenanceImage}
            />
          </div>

          <div className={styles.rightContainer}>
            <p className={styles.title}>
              Sorry :'(
            </p>

            <p className={styles.description}>
              Platform under maintenance
            </p>

            <p className={styles.statusLink}>
              <a href='https://status.scite.ai/en/' target='_blank' rel='noopener noreferrer'>
                Check status
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MaintenanceApp
